import type { ActivityUsageBucket, ActivityUsageTimeline } from "./api";
import { duration } from "./format";

// Cores compartilhadas entre o gráfico temporal e as barras do relatório.
export const usageColors = [
  "#e43b40",
  "#f08b33",
  "#e8c547",
  "#42d3aa",
  "#3aa9e8",
  "#7b7bf0",
  "#c65de0",
  "#e05d9a",
  "#8bd450",
  "#6ad0d8",
];

export function UsageTimelineChart({
  timeline,
  processOrder,
  buckets,
  title,
}: {
  timeline?: ActivityUsageTimeline | null;
  processOrder: string[];
  buckets?: ActivityUsageBucket[];
  title?: string;
}) {
  const columns = buckets ?? timeline?.buckets ?? [];
  if (!timeline || !columns.length) return null;
  const totals = columns.map((bucket) => bucket.slices.reduce((sum, slice) => sum + slice.seconds, 0));
  const maximum = Math.max(1, ...totals);
  const colorFor = (process: string) => {
    if (process === "Outros") return "#5a5a63";
    const index = processOrder.indexOf(process);
    return usageColors[(index >= 0 ? index : 0) % usageColors.length];
  };
  const formatBucket = (start: string) => {
    const date = new Date(start);
    return timeline.bucketMinutes >= 1440
      ? date.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" })
      : date.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  };
  const step = Math.max(1, Math.ceil(columns.length / 12));
  const label =
    timeline.bucketMinutes >= 1440
      ? "por dia"
      : timeline.bucketMinutes >= 60
        ? `por ${timeline.bucketMinutes / 60}h`
        : `por ${timeline.bucketMinutes} min`;
  const legend = Array.from(new Set(columns.flatMap((bucket) => bucket.slices.map((slice) => slice.process))))
    .sort((a, b) => processOrder.indexOf(a) - processOrder.indexOf(b));
  return (
    <div className="usage-timeline">
      <div className="panel-title">
        <h3>{title ?? "Uso ao longo do tempo"}</h3>
        <span>{label}</span>
      </div>
      <div className="usage-timeline-bars" role="img" aria-label="Tempo por programa ao longo do período">
        {columns.map((bucket, index) => (
          <div className="usage-timeline-col" key={bucket.start}>
            {bucket.slices.map((slice) => (
              <i
                key={slice.process}
                title={`${formatBucket(bucket.start)} · ${slice.process}: ${duration(slice.seconds)}`}
                style={{ height: `${(slice.seconds / maximum) * 100}%`, background: colorFor(slice.process) }}
              />
            ))}
            <span>{index % step === 0 ? formatBucket(bucket.start) : ""}</span>
          </div>
        ))}
      </div>
      <div className="usage-legend">
        {legend.map((process) => (
          <span key={process}>
            <i style={{ background: colorFor(process) }} />
            {process}
          </span>
        ))}
      </div>
    </div>
  );
}
